module.exports = __webpack_public_path__ + "static/wire-about-3-c4cb91418fcb26f9bb11266656e802f7.png";